import {css} from '@emotion/react'
import {Radio} from 'antd'
import {useReadOnly} from './ReadOnly.mjs'

const cssRadioGroup = css({
    display: 'flex',
    flexWrap: 'wrap',
})

const cssRadio = css({
    flexGrow: 1,
    borderRadius: '0 !important',
    marginRight: -1,
    marginBottom: -1,

    '&.ant-radio-button-wrapper:not(:first-child)': {
        borderLeftWidth: 1,

        '&::before': {
            display: 'none',
        },
    },
})

const cssLabel = css({
    display: 'flex',
    alignItems: 'center',
    flexGrow: 1,
    gap: 8,
})

const cssIcon = css({
    display: 'grid',
    width: 16,
    height: 16,
})

const defaultOptions = []

const Label = ({children, icon, ...props}) => {
    return (
        <div
            css={cssLabel}
            {...props}
        >
            {icon && <div css={cssIcon}>{icon}</div>}
            {children}
        </div>
    )
}

export default function RadioGroup({
    readOnly,
    options = defaultOptions,
    onChange,
    ...props
}) {
    const gReadOnly = useReadOnly()

    const children = options.map(
        ({value, icon, label = value}) => (
            <Radio.Button
                css={cssRadio}
                key={value}
                value={value}
            >
                <Label icon={icon}>
                    {label}
                </Label>
            </Radio.Button>
        )
    )

    const handleChange = readOnly || gReadOnly || ! onChange ?
        null
        :
        ({target: {value}}) => onChange(value)

    return (
        <Radio.Group
            css={cssRadioGroup}
            buttonStyle="solid"
            optionType="button"
            onChange={handleChange}
            {...props}
        >
            {children}
        </Radio.Group>
    )
}
